KM3D.scenes.delici = function (T, M, KM) {
  var P = Math.PI, root = new T.Group(), Z0 = -0.25, MX = -4.2, SZ = Z0 + 0.45;
  function add(m, x, y, z, p) { m.position.set(x, y, z); (p || root).add(m); return m; }
  function box(w, h, d, mat, x, y, z, p) { return add(new T.Mesh(new T.BoxGeometry(w, h, d), mat), x, y, z, p); }
  function cylZ(r, len, mat, seg) { var g = new T.CylinderGeometry(r, r, len, seg || 28); g.rotateX(P / 2); return new T.Mesh(g, mat); }
  function rr(w, h, r) { var s = new T.Shape(); s.moveTo(-w + r, -h); s.lineTo(w - r, -h); s.quadraticCurveTo(w, -h, w, -h + r); s.lineTo(w, h - r); s.quadraticCurveTo(w, h, w - r, h); s.lineTo(-w + r, h); s.quadraticCurveTo(-w, h, -w, h - r); s.lineTo(-w, -h + r); s.quadraticCurveTo(-w, -h, -w + r, -h); return s; }
  function rb(w, h, d, r, mat, x, y, z, p) {
    var g = new T.ExtrudeGeometry(rr(w / 2 - 0.05, h / 2 - 0.05, r), { depth: d - 0.1, bevelEnabled: true, bevelThickness: 0.05, bevelSize: 0.05, bevelSegments: 2, curveSegments: 5 });
    g.translate(0, 0, -(d - 0.1) / 2);
    return add(new T.Mesh(g, mat), x, y, z, p);
  }
  function link(ax, ay, bx, by, h, d, mat, z) {
    var dx = bx - ax, dy = by - ay, L = Math.sqrt(dx * dx + dy * dy);
    var m = new T.Mesh(new T.BoxGeometry(L, h, d), mat); m.position.set((ax + bx) / 2, (ay + by) / 2, z); m.rotation.z = Math.atan2(dy, dx); root.add(m); return m;
  }
  function cyl2(ax, ay, bx, by, r, mat, z) {
    var dx = bx - ax, dy = by - ay, L = Math.sqrt(dx * dx + dy * dy);
    var m = new T.Mesh(new T.CylinderGeometry(r, r, L, 14), mat); m.position.set((ax + bx) / 2, (ay + by) / 2, z); m.rotation.z = Math.atan2(dy, dx) - P / 2; root.add(m); return m;
  }
  function hyd(ax, ay, bx, by, z) {
    var dx = bx - ax, dy = by - ay, L = Math.sqrt(dx * dx + dy * dy), ux = dx / L, uy = dy / L;
    cyl2(ax, ay, ax + ux * L * 0.56, ay + uy * L * 0.56, 0.1, M.dark, z);
    cyl2(ax + ux * L * 0.5, ay + uy * L * 0.5, bx, by, 0.052, M.chrome, z);
  }
  // ---- crawler tracks ----
  var tpts = [[-2.55, 0.55], [-2.2, 0.08], [-1.2, 0.04], [1.2, 0.04], [2.2, 0.08], [2.6, 0.55], [2.3, 1.05], [1.4, 1.15], [-1.4, 1.15], [-2.3, 1.05]]
    .map(function (p) { return new T.Vector3(p[0], p[1], 0); });
  var curve = new T.CatmullRomCurve3(tpts, true, 'catmullrom', 0.5), LEN = curve.getLength(), N = 48;
  function track(z) {
    var plate = new T.InstancedMesh(new T.BoxGeometry(LEN / N * 0.95, 0.07, 0.72), M.shoe, N);
    var grou = new T.InstancedMesh(new T.BoxGeometry(0.12, 0.1, 0.7), M.black, N);
    var d = new T.Object3D(), pp = new T.Vector3(), tt = new T.Vector3(), i;
    for (i = 0; i < N; i++) {
      var u = i / N; curve.getPointAt(u, pp); curve.getTangentAt(u, tt);
      d.position.set(pp.x, pp.y, z); d.rotation.set(0, 0, Math.atan2(tt.y, tt.x)); d.updateMatrix(); plate.setMatrixAt(i, d.matrix);
      d.position.set(pp.x + tt.y * 0.08, pp.y - tt.x * 0.08, z); d.updateMatrix(); grou.setMatrixAt(i, d.matrix);
    }
    root.add(plate); root.add(grou);
    box(4.5, 0.4, 0.5, M.dark, 0, 0.58, z);
    var spr = cylZ(0.5, 0.62, M.dark, 32); add(spr, 2.1, 0.55, z);
    add(cylZ(0.26, 0.7, M.steel, 20), 2.1, 0.55, z);
    var idl = cylZ(0.5, 0.62, M.dark, 32); add(idl, -2.1, 0.55, z);
    add(cylZ(0.26, 0.7, M.yellow, 20), -2.1, 0.55, z);
    [-1.2, -0.4, 0.4, 1.2].forEach(function (x) { add(cylZ(0.17, 0.62, M.steel, 16), x, 0.22, z); });
    [-0.9, 0.9].forEach(function (x) { add(cylZ(0.13, 0.62, M.steel, 14), x, 0.98, z); });
  }
  track(-1.3); track(1.3);
  // ---- body ----
  rb(5.2, 0.55, 2.0, 0.1, M.yellow, 0, 1.35, 0);
  rb(1.8, 1.15, 2.0, 0.2, M.yellow, 1.75, 2.2, 0);
  box(1.5, 0.08, 1.9, M.dark, 1.75, 2.8, 0);
  var tank = new T.Mesh(new T.CylinderGeometry(0.5, 0.5, 1.5, 28), M.black); add(tank, 3.05, 2.0, 0);
  add(new T.Mesh(new T.CylinderGeometry(0.4, 0.5, 0.18, 28), M.dark), 3.05, 2.84, 0);
  add(new T.Mesh(new T.CylinderGeometry(0.52, 0.52, 0.1, 28), M.yellow), 3.05, 1.2, 0);
  add(new T.Mesh(new T.CylinderGeometry(0.1, 0.1, 0.7, 12), M.dark), 1.45, 3.15, 0.6);
  add(new T.Mesh(new T.CylinderGeometry(0.16, 0.16, 0.3, 14), M.black), 2.1, 3.0, -0.5);
  // ---- cab ----
  var CX = 0.15, CZ = 0.55;
  box(1.5, 0.3, 1.2, M.yellow, CX, 1.8, CZ);
  [[-1, -1], [-1, 1], [1, -1], [1, 1]].forEach(function (s) { box(0.09, 1.5, 0.09, M.yellow, CX + s[0] * 0.7, 2.55, CZ + s[1] * 0.55); });
  rb(1.7, 0.14, 1.4, 0.06, M.yellow, CX, 3.35, CZ);
  add(new T.Mesh(new T.BoxGeometry(1.44, 1.3, 1.1), M.glass), CX, 2.6, CZ);
  box(0.5, 0.1, 0.5, M.black, CX + 0.1, 2.0, CZ); box(0.1, 0.65, 0.5, M.black, CX + 0.38, 2.35, CZ);
  box(0.3, 0.3, 0.3, M.dark, CX - 0.45, 2.05, CZ);
  add(new T.Mesh(new T.SphereGeometry(0.1, 12, 10), M.red), CX + 0.4, 3.47, CZ);
  [-0.4, 0.4].forEach(function (z) { box(0.12, 0.14, 0.2, M.white, CX - 0.78, 3.35, CZ + z); });
  // ---- boom ----
  var A = [-1.2, 1.9], B = [-2.55, 3.0], C = [-3.85, 2.45];
  rb(0.6, 0.75, 0.7, 0.1, M.yellow, A[0] + 0.05, A[1] - 0.1, Z0);
  link(A[0], A[1], B[0], B[1], 0.36, 0.42, M.yellow, Z0);
  link(B[0], B[1], C[0], C[1], 0.3, 0.38, M.yellow, Z0);
  [A, B, C].forEach(function (p) { add(cylZ(0.17, 0.62, M.dark, 18), p[0], p[1], Z0); });
  hyd(-0.55, 1.7, -1.85, 2.5, Z0 - 0.5);
  hyd(-1.9, 3.2, -3.3, 2.95, Z0 - 0.45);
  var hose = new T.CatmullRomCurve3([new T.Vector3(-2.5, 2.75, 0.15), new T.Vector3(-2.9, 1.95, 0.35), new T.Vector3(-3.5, 1.9, 0.35), new T.Vector3(-3.95, 2.5, 0.2)]);
  add(new T.Mesh(new T.TubeGeometry(hose, 24, 0.05, 8, false), M.black), 0, 0, 0);
  var hose2 = new T.CatmullRomCurve3([new T.Vector3(-2.2, 2.6, -0.5), new T.Vector3(-2.7, 1.7, -0.2), new T.Vector3(-3.4, 1.65, 0.1), new T.Vector3(-3.95, 2.2, 0.1)]);
  add(new T.Mesh(new T.TubeGeometry(hose2, 24, 0.05, 8, false), M.black), 0, 0, 0);
  // ---- feed (mast) ----
  rb(0.6, 0.95, 0.7, 0.1, M.yellow, MX + 0.28, C[1], Z0);
  box(0.34, 4.5, 0.5, M.black, MX, 2.45, Z0);
  box(0.06, 4.3, 0.06, M.yellow, MX - 0.12, 2.45, Z0 + 0.28); box(0.06, 4.3, 0.06, M.yellow, MX + 0.12, 2.45, Z0 + 0.28);
  rb(0.6, 0.4, 0.7, 0.08, M.yellow, MX, 4.85, Z0);
  add(cylZ(0.26, 0.2, M.dark, 24), MX, 4.45, Z0 + 0.4);
  rb(0.85, 0.5, 0.85, 0.08, M.yellow, MX, 0.35, Z0 + 0.1);
  box(1.0, 0.07, 1.0, M.dark, MX, 0.035, Z0 + 0.1);
  add(new T.Mesh(new T.CylinderGeometry(0.2, 0.2, 0.3, 20), M.dark), MX, 0.7, SZ);
  // ---- drifter + drill steel ----
  var D = new T.Group(); D.position.set(MX, 3.9, SZ); root.add(D);
  rb(0.62, 1.0, 0.55, 0.1, M.yellow, 0, 0.05, -0.26, D);
  add(new T.Mesh(new T.CylinderGeometry(0.22, 0.22, 0.4, 24), M.dark), 0, -0.55, 0, D);
  var S = new T.Group(); D.add(S);
  add(new T.Mesh(new T.CylinderGeometry(0.075, 0.075, 1.8, 16), M.steel), 0, -1.6, 0, S);
  var heli = KM.spring(T, 0.105, 1.7, 14, 0.022, M.chrome); heli.position.y = -2.45; S.add(heli);
  add(new T.Mesh(new T.CylinderGeometry(0.16, 0.12, 0.2, 14), M.dark), 0, -2.6, 0, S);
  // ---- dust ----
  var dust = [], i;
  for (i = 0; i < 7; i++) {
    var dm = new T.MeshBasicMaterial({ color: 0xb9a58c, transparent: true, opacity: 0, depthWrite: false });
    var ds = new T.Mesh(new T.SphereGeometry(0.14, 10, 8), dm); ds.position.set(MX, 0.15, SZ); root.add(ds); dust.push(ds);
  }
  add(KM.shadow(T, 13, 5.5, -0.02, 0.8), -0.55, -0.02, 0);
  function update(t, dt, speed) {
    var p = (t * 0.32) % 1, down = p < 0.72, d = down ? p / 0.72 : 1 - (p - 0.72) / 0.28;
    if (!down) d = d * d * (3 - 2 * d);
    D.position.y = 3.9 - 1.1 * d + (down ? Math.sin(t * 90) * 0.012 * speed : 0);
    S.rotation.y = t * 7;
    var amt = speed * (down ? 1 : 0.2) * (d > 0.04 ? 1 : 0);
    for (var k = 0; k < dust.length; k++) {
      var u = (t * 1.1 + k / dust.length) % 1, a = k * 2.4;
      dust[k].position.set(MX + Math.cos(a) * u * 0.9, 0.15 + u * 0.9, SZ + Math.sin(a) * u * 0.9);
      dust[k].scale.setScalar(0.5 + u * 1.6);
      dust[k].material.opacity = (1 - u) * 0.55 * amt;
    }
  }
  root.position.set(0.55, -2.45, 0);
  return { root: root, update: update, pose: 0.9, cam: { fov: 30, p: [5.3, 3.8, 12.6], l: [0, 0.1, 0] } };
};
